// This file is automatically generated. Do not edit manually.

import { DocumentTemplateView } from "src/api/generated/postgres/db/types/documents/tables/documentTemplateView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DocumentTemplateApi {
	export async function getDocumentTemplates(): Promise<Array<DocumentTemplateView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/documents/documentTemplate/getDocumentTemplates",
			method: "POST",
			data: {},
		});
		return response as Array<DocumentTemplateView>;
	}
}
